import { cn } from "../lib/utils";

export function ComplianceJourneyTimeline({ className }) {
  return (
    <div className={cn("glass-card p-6", className)}>
      <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
        Your RBI compliance journey
      </div>
      <h3 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">
        12-week execution plan
      </h3>

      <div className="mt-6 grid gap-3 lg:grid-cols-4">
        {[
          {
            w: "Week 1–2",
            t: "Gap Assessment",
            d: ["Gap report", "Risk rating", "Roadmap"],
          },
          {
            w: "Week 3–4",
            t: "Control Design",
            d: ["Control map", "Policy drafts", "Procedures"],
          },
          {
            w: "Week 5–8",
            t: "Tool Deploy",
            d: ["Deployed tools", "Integration", "Testing"],
          },
          {
            w: "Week 9–12",
            t: "Evidence Pipeline",
            d: ["Automated evidence", "Compliance dashboard", "Audit readiness"],
          },
        ].map((s) => (
          <div key={s.w} className="rounded-2xl border border-border-subtle bg-white/5 p-5">
            <div className="font-mono text-xs font-semibold text-text-secondary">
              {s.w}
            </div>
            <div className="mt-2 text-lg font-semibold text-text-primary">
              {s.t}
            </div>
            <div className="mt-4 space-y-2">
              {s.d.map((x) => (
                <div key={x} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary">
                  {x}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
